import React, { useState, useEffect } from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import MoonLoader from 'react-spinners/MoonLoader';
import { useAPI } from '../../ApiCalls/useAPI';

const Noticeboard = () => {
    const [Notice, setNotice] = useState('');

    useEffect(() => {
        const { getNoticeBoard } = useAPI();
        getNoticeBoard()
            .then((data) => {
                setNotice(data);
            })
            .catch((error) => console.error(error));
    }, []);

    const override = `
        display: block;
        margin: 10% auto;
        border-color: red;
    `;
    if (Notice === null) {
        return (
            <div>
                <h1 className="mt-4" style={{ textAlign: 'center' }}>
                    Waiting for data ...
                </h1>
                <MoonLoader
                    color={'green'}
                    isLoading={true}
                    css={override}
                    size={60}
                />
            </div>
        );
    } else {
        return (
            <div className="container">
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Notice Board</div>
                </div>
                <div
                    className="container"
                    dangerouslySetInnerHTML={{
                        __html: Notice.replace(
                            /(<ion-header-bar[\w\W]+ion-header-bar>)/g,
                            ''
                        )
                    }}
                />
            </div>
        );
    }
};

export default Noticeboard;
